module.exports = __webpack_public_path__ + "d4e579aea5a0c660c765f78c7d27148f.png";